// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"8aacc965","275":"ec681615","291":"c64b3611","328":"79eef741","371":"b61e4f72","386":"d9e2b9bc","398":"674b25c9","486":"03aa6089","554":"6157dceb","561":"6d5118ff","626":"3f818064","717":"1fa1bb3b","994":"c516ee11"}[chunkId] + ".chunk.js";
};